import { useChat } from '@r1-frontend/entities/Chat/hooks/useChat';

import { Link } from './styled';

interface IProps {
    children?: JSX.Element | JSX.Element[] | string,
    clickHandle?: () => void,
}

const OpenChatLink = ({ children = 'чат', clickHandle }: IProps): JSX.Element => {
    const { open } = useChat();

    const onClick = () => {
        open();

        if (typeof clickHandle === 'function') {
            clickHandle();
        }
    };

    return <Link onClick={onClick}>{children}</Link>;
};

export default OpenChatLink;
